import { FC } from 'react';
import { observer } from 'mobx-react';
import { useStores } from 'stores';
import styles from './styles.module.scss';

type Props = {
  spinning?: boolean;
};

const Spinner: FC<Props> = ({ spinning }) => {
  const {
    spinnerStore: { isSpinning },
  } = useStores();

  return (
    <>
      {(isSpinning || spinning) && (
        <div className={styles.bns3_spinner}>
          <div className={styles.bns3_spinner_border} role="status" />
        </div>
      )}
    </>
  );
};

export default observer(Spinner);
